import { AppState as Auth0AppState, Auth0Provider } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import { RefreshTokenKeepingCache } from 'utils/helpers/auth0RefreshTokenCache';

const refreshTokenCache = new RefreshTokenKeepingCache();

// Route /oauth/token via savi-api so Auth0 does not see the browser Origin and suppress refresh tokens.
const originalFetch = window.fetch.bind(window);
window.fetch = (input: RequestInfo | URL, init?: RequestInit) =>
  String(input).endsWith('/oauth/token')
    ? originalFetch(`${process.env.REACT_APP_SAVI_API_HOST}/api/v2/users/oauth-token`, init)
    : originalFetch(input, init);

const Auth0ProviderWithHistory: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();

  const onRedirectCallback = (appState: Auth0AppState | undefined) => {
    navigate(appState?.returnTo || window.location.pathname);
  };

  return (
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN ?? ''}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID ?? ''}
      audience={process.env.REACT_APP_AUTH0_AUDIENCE}
      redirectUri={window.location.origin}
      onRedirectCallback={onRedirectCallback}
      scope="openid profile email offline_access"
      cache={refreshTokenCache}
      useRefreshTokens
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;
